const setStatus = (ele: HTMLElement) : void => {
  // Data / Variables
  const { status } = ele.dataset;

  // Update chat
  const chats: NodeListOf<HTMLElement> = document.querySelectorAll('.content-status__chat-content');
  const stepChats: NodeListOf<HTMLElement> = document.querySelectorAll('.step-chat');

  [...chats].forEach((chat) => {
    const chatParent = chat.closest('.content-status__info');
    const chatImage: HTMLElement = chatParent.querySelector(`.content-status__user[data-status="${chat.dataset.status}"]`);

    chat.classList.remove('content-status__chat-content--active');
    chatImage.classList.remove('content-status__user--active');

    if (chat.dataset.status === status) {
      chat.classList.add('content-status__chat-content--active');
      chatImage.classList.add('content-status__user--active');
    }
  });

  [...stepChats].forEach((chat) => {
    chat.classList.remove('step-chat--active');

    if (chat.dataset.status === status) {
      chat.classList.add('step-chat--active');
    }
  });
};

export default setStatus;
